import {ErrorHandler, ErrorDescriptionService} from 'hasta-la-vista-middleware-api/service'

export default {
    data () {
        return {
            toggleDialog: false,
            sysError: '',
            loading: true,
            activationDialog: false,
            showGoogleTagManager: false,
            foo: "no"
        }
    },

    methods: {
        okay(to, from) {
            this.toggleDialog = false
            // this.$router.push('/')
        },
        resendActivation() {
            this.activationDialog = true
        },
        googleTagManager() {
            // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            // })(window,document,'script','dataLayer','GTM-NXD8NB6');

            this.showGoogleTagManager = true

            return this.showGoogleTagManager
        },
        humanzScript() {
            function lHzpAsy(u, c) {
                var d = document, t = 'script',
                o = d.createElement(t),
                s = d.getElementsByTagName(t)[0];
                o.src = u;
                if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
                    s.parentNode.insertBefore(o, s);
                }
                lHzpAsy("https://assets.humanz.com/2633024/humanz-gtm.js", function () {
                try {
                    var hmz = new window.hzi("2633024");
                } catch (e) { }
                });
        }
    },

    created() {

        window.scroll({top: 0, left: 0})

        this.googleTagManager()
        this.humanzScript()

        // let testCrawlers = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)

        // if(!testCrawlers) {
            ErrorHandler.handle((r)=>r, (error)=> {
                let errorMessage = 'unknown error';

                let showErrorMessages = true;

                if(window.__PRERENDER_INJECTED) {
                    showErrorMessages = false;
                }

                if(error && showErrorMessages) {
                    if (error.response) {
                        errorMessage = JSON.parse(error.response.request.responseText)
                    } else {
                        if(showErrorMessages) {
                            // console.log(JSON.stringify(error));
                        
                            errorMessage = {
                                error_code:0,
                                error_type:"Unknown",
                                error:["Sorry, but we're unable to connect right now. Please try again a bit later."],
                                error_string:"Sorry, but we're unable to connect right now. Please try again a bit later."
                            }
                        }
                    }


                    if(errorMessage.error_string != "Unable to Update Order") {
                        let skErrorDesc = ErrorDescriptionService.getErrorFromCode(errorMessage.error_code, errorMessage.error_type, errorMessage)

                        if (skErrorDesc) {
                            errorMessage.error_string = skErrorDesc.errorDescription
                            errorMessage.dialog = skErrorDesc.dialog
                        } else {
                            errorMessage.dialog = true;
                        }
                        if (errorMessage.dialog) {
                            this.toggleDialog = true
                            this.sysError = errorMessage.error_string
                        } else {
                            this.toastOptions = this.$breakpoints.xs ? {fixed: true, timeout: null} : {
                                top: true,
                                fullwidth: true,
                                timeout: null
                            }
                            this.$toaster.show((errorMessage.error_string), this.toastOptions);
                        }
                        // don't make this return error string, it will break the whole system when it comes to handling failed promises
                        return errorMessage
                    }
                }
            })
        // }
        this.loading = false
    },
    mounted() {
        if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.foo) {
            this.foo = window.__PRERENDER_INJECTED.foo
        }
    },
}



// WEBPACK FOOTER //
// ./src/app.js